import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=7b8e487d&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=7b8e487d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8e487d",
  null
  
)

export default component.exports